import { For, JSX, Show } from 'solid-js';
import type { BotLicenseAssignmentDto } from '../api';
import Text from './Text';
import { Badge } from './Badge';
import { RelativeTime } from './RelativeTime';
import styles from './BotLicenseAssignmentList.module.css';

interface BotLicenseAssignmentListProps {
    assignments: BotLicenseAssignmentDto[];
    actions: (assignment: BotLicenseAssignmentDto) => JSX.Element;
}

export default function BotLicenseAssignmentList(props: BotLicenseAssignmentListProps) {
    return (
        <Show when={props.assignments.length > 0} fallback={
            <span class={styles.empty}><Text val="BOT_LICENSE_NONE_ASSIGNED" /></span>
        }>
            <ul class={styles.list}>
                <For each={props.assignments}>{(assignment) => (
                    <li class={styles.row}>
                        <span class={styles.botName}>
                            <Show when={assignment.botName} fallback={<Text val="BOT_LICENSE_BOT_DELETED" />}>{assignment.botName}</Show>
                        </span>
                        <Show when={assignment.state === 'Active'}>
                            <Badge tone="success"><Text val="BOT_LICENSE_STATE_ACTIVE" /></Badge>
                        </Show>
                        <Show when={assignment.state === 'Grace'}>
                            <Badge tone="warning"><Text val="BOT_LICENSE_STATE_GRACE" /></Badge>
                            <span class={styles.when}><RelativeTime value={assignment.graceEndsAt} showAbsolute /></span>
                        </Show>
                        <Show when={assignment.state === 'Cooldown'}>
                            <Badge tone="neutral"><Text val="BOT_LICENSE_STATE_COOLDOWN" /></Badge>
                            <span class={styles.when}><RelativeTime value={assignment.cooldownEndsAt} showAbsolute /></span>
                        </Show>
                        <span class={styles.actions}>{props.actions(assignment)}</span>
                    </li>
                )}</For>
            </ul>
        </Show>
    );
}
